function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#72163b;}.cls-2{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M12.25,23.5A11.25,11.25,0,1,1,23.5,12.25,11.26,11.26,0,0,1,12.25,23.5Z",
  fill: "#72173b"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M12.25,2A10.25,10.25,0,1,1,2,12.25,10.25,10.25,0,0,1,12.25,2m0-2A12.25,12.25,0,1,0,24.5,12.25,12.27,12.27,0,0,0,12.25,0Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M5.42,13.47V11a.35.35,0,0,1,.37-.35h4.44a.36.36,0,0,0,.36-.36V6A.37.37,0,0,1,11,5.68h2.58a.36.36,0,0,1,.37.35V10.3a.37.37,0,0,0,.37.36h4.44a.35.35,0,0,1,.36.35v2.46a.36.36,0,0,1-.36.35H14.28a.37.37,0,0,0-.37.36v4.29a.36.36,0,0,1-.37.35H11a.37.37,0,0,1-.37-.35V14.18a.36.36,0,0,0-.36-.36H5.79A.36.36,0,0,1,5.42,13.47Z"
});

var SvgFocusPlus = function SvgFocusPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Room-focus-icons",
    viewBox: "0 0 24.5 24.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFocusPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/focus-plus.67f4a9e5.svg";
export { ForwardRef as ReactComponent };